import { PosIconProps, SvgWrapper } from './SvgWrapper';

export const AnchorIcon = (props: PosIconProps) => {
  return (
    <SvgWrapper
      {...props}
      fill="none" // this one cannot have any fill
      viewBox="0 0 12 12" // The viewbox here is important as it won't display properly without this specific value
    >
      <path
        d="M9.44557 7.79563L8.62062 6.97068L9.44557 6.14573C10.5846 5.00671 10.5846 3.15997 9.44557 2.02094C8.30656 0.881908 6.45978 0.881908 5.32077 2.02094L4.49581 2.8459L3.67085 2.02094L4.49581 1.19598C6.09047 -0.39866 8.67587 -0.39866 10.2705 1.19598C11.8652 2.79062 11.8652 5.37602 10.2705 6.97068L9.44557 7.79563ZM7.79562 9.44559L6.97067 10.2705C5.37607 11.8651 2.79062 11.8651 1.19598 10.2705C-0.39866 8.67588 -0.39866 6.09043 1.19598 4.49582L2.02094 3.67085L2.8459 4.49582L2.02094 5.32078C0.881908 6.45979 0.881908 8.30651 2.02094 9.44559C3.15996 10.5846 5.0067 10.5846 6.14572 9.44559L6.97067 8.62058L7.79562 9.44559ZM7.38314 3.25838L8.20815 4.08333L4.08333 8.2081L3.25837 7.38315L7.38314 3.25838Z"
        fill={props.fill ?? '#671DE7'}
      />
    </SvgWrapper>
  );
};
